export default __webpack_public_path__ + "static/media/dacia.0054fc5d.svg";